module.exports = __webpack_public_path__ + "static/hkgrotesk-semibold-28d43353b758a7294986605ecb965401.woff";